import React, { useState } from 'react'
import Marquee from "react-fast-marquee";
// import rajeev from "../director../images/rajeevahuja.png";
import Ares from "../../images/Ares.jpeg";
import ease from "../../images/easecruit.png";
import Bodyloop from "../../images/BODYLOOP_LABS.jpg";
import chematico from "../../images/chematico.jpeg";
import dakters from "../../images/Dakters.jpg";
import edith from "../../images/edith_health.jpeg";
import epilepto from "../../images/epilepto.png";
import evigway from "../../images/evigway.jpeg";
import fulectronix from "../../images/FULECTRONIX_TECHNOLOGY.jpg";
import greeninv from "../../images/GREEN_INNOVOTECH.jpg";
import jyoma from "../../images/JYOMA_SOLUTIONS.jpg";
import logier from "../../images/logier.png";
import nanokriti from "../../images/nanokriti.png";
import neontram from "../../images/Neontram.jpg";
import renao from "../../images/renao.jpg";
import rosch from "../../images/rosch-crete.jpg";
import scratchnest from "../../images/Scratchnest.png";
import wevixit from "../../images/wevixit.jpeg";
import yoboshu from "../../images/yoboshu.png";
import { motion } from "framer-motion";
import vanix from "../../images/vanix.png";
import "./portfolio.css"
import { ExternalLink } from 'lucide-react';
import ironfist from "../../images/ironfist.png";
import texoedge from "../../images/Texoedge.jpg"
// import IITRopar from "./MouImg/IITRopar.png";
import { Link } from 'react-router-dom';
import backg from '../../global-images/vector-about.png';
import { faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons';

const marqueeData = [
  {
    img: texoedge,
    name: "Texoedge",
    link: "https://texoedge.in/"
  },
  {
    img: jyoma,
    name: "Jyoma Solutions Pvt Ltd",
    description: "Easecruit is a company that provides ",
    link: "https://jyomasolutions.com/"
  },
  {
    img: evigway,
    name: "Evigway Technologies Pvt Ltd",
    description: "Ares Systems is a company that provides ",
    link: "http://www.evigway.com/"
  },
  {
    img: chematico,
    name: "Chematico Technologies Pvt Ltd",
    link: "http://www.chematico.com/",
    description: "Bodyloop labs is a company that provides ",
  },
  {
    img: rosch,
    name: "Roschcrete Technologies Pvt Ltd",
    link: "http://roschcrete.com/",
    description: "Edith Robotics Solutions is a company that provides ",
  },
  {
    img: vanix,
    name: "Vanix Technologies Pvt Ltd",
    link: "https://vanixtechnologies.com/",
    description: "ScratchNest is a company that provides ",
  },
  {
    img: fulectronix,
    name: "Fulectronix Technologies Pvt Ltd",
    link: "http://www.fulectronix.in/",
    description: "Vanix Technologies is a company that provides ",
  },
  {
    img: greeninv,
    name: "Green Innovotech Solutions Pvt Ltd",
    link: "http://www.greeninnovotech.com/",
    description: "Yoboshu is a company that provides ",
  },
  {
    img: renao,
    name: "Renao Robotics Pvt Ltd",
    link: "https://www.nanokriti.com/",
    description: "Logier Technologies is a company that provides ",
  },
  {
    img: Ares,
    name: "Ares Systems Pvt Ltd",
    link: "http://www.aressystems.io/",
    description: "Jyoma Solutions is a company that provides ",
  },
  {
    img: ironfist,
    name: "Ironfist Arms Pvt Ltd",
    link: "https://www.ironfistarms.org/",
    description: "Iron Fist Arms is a company that provides ",
  },

];
const sortedMarqueeData = marqueeData.sort((a, b) => {
  const nameA = a.name.toUpperCase(); // Ignore case
  const nameB = b.name.toUpperCase(); // Ignore case

  if (nameA < nameB) {
    return -1;
  }
  if (nameA > nameB) {
    return 1;
  }

  // Names must be equal
  return 0;
});
console.log(sortedMarqueeData);
const itemsPerPage = 6;


function DefenceStartup() {
  const [currentPage, setCurrentPage] = useState(1);
  const element = document.getElementById('portfolio-box');
  const totalPages = Math.ceil(marqueeData.length / itemsPerPage);

  const handleClickNext = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
    if (element) {
      window.scrollTo({
        top: element.offsetTop,
        behavior: 'smooth'
      });
    }
  };

  // const handleClickPrev = () => {
  //   if (currentPage > 1) {
  //     setCurrentPage(currentPage - 1);
  //   }
  //   if (element) {
  //     window.scrollTo({
  //       top: element.offsetTop,
  //       behavior: 'smooth'
  //     });
  //   }
  // };
  const currentItems = marqueeData.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

  return (
    // <div className='w-screen'>
    <div className='bg-white flex items-center justify-center  lg:py-20  md:py-15 sm:py-20 xs:py-20 ' id="portfolio">
      <div>
        <div className='p-9'>
          <div className='md:text-5xl text-4xl md:flex md:justify-center gap-2 font-serif text-black text-center '> 
            <div className='text-blue-600'>Defence</div><div>Based Startups</div> </div>
        </div>
        <div className='rounded-3xl '>
          <div className=' flex justify-center  items-center font-montserrat relative'>
            {/* <div id='circle-1' className='absolute w-72 h-72 lg:top-0 lg:left-0 sm:top-50 sm:left-0 bg-purple-400 rounded-full mix-blend-multiply filter blur-lg opacity-80'></div> */}

            <div className=' flex grid grid-cols-1 flex justify-center items-center relative p-6 '>
              {/* <div id='circle-3' className='absolute w-72 h-72 lg:top-0 lg:left-0 sm:top-0 sm:left-0 bg-red-400 animate-pulse  rounded-full mix-blend-multiply filter blur-lg opacity-80'></div> */}
              {/* <div id='circle-2' className='absolute w-72 h-72 lg:top-40 lg:left-0 sm:top-0 sm:left-10 bg-indigo-400 rounded-full mix-blend-multiply filter blur-lg opacity-80'></div> */}

              <div className='bg-white flex items-center justify-center' >
                <div className='  rounded-3xl'>
                  <div className=' flex justify-center  items-center font-montserrat relative'>
                    {/* <div id='circle-1' className='absolute w-72 h-72 lg:top-0 lg:left-0 sm:top-50 sm:left-0 bg-purple-400 rounded-full mix-blend-multiply filter blur-lg opacity-80'></div> */}

                    <div className=' flex grid grid-cols-1 flex justify-center items-center relative '>
                      {/* <div id='circle-3' className='absolute w-72 h-72 lg:top-0 lg:left-0 sm:top-0 sm:left-0 bg-red-400 animate-pulse  rounded-full mix-blend-multiply filter blur-lg opacity-80'></div> */}
                      {/* <div id='circle-2' className='absolute w-72 h-72 lg:top-40 lg:left-0 sm:top-0 sm:left-10 bg-indigo-400 rounded-full mix-blend-multiply filter blur-lg opacity-80'></div> */}


                      < div className=' flex grid lg:grid-cols-4 md:grid-cols-2 gap-8  sm:grid-cols-1 ' id='portfolio-box'>
                        {marqueeData.map((portfolio, index) => (
                          <div className='flex justify-center items-center  '>
                            <div className='border  border-5 transition-all hover:scale-105 duration-75 rounded-xl hover:transition hover:ease-in-out   hover:text-white hover:duration-500  border-red-400 flex grid grid-cols-1 card img-card flex justify-center items-center hover:shadow-2xl bg-zinc-900  hover:border-2' id="startup box">
                              <div className='flex  justify-center items-center '><img className='rounded-full hover:rounded-lg bg-white ' src={portfolio.img}></img></div>
                              <div className='bg-opacity-30'>
                                <div className=' text-center text-xl font-montserrat text-white hover:underline hover:underline-offset-4' id='title'>{portfolio.name}</div>
                              </div>
                              <a className='flex justify-around items-center ' href={portfolio.link} target='_blank'>
                                <button className='p-3 rounded-2xl '>
                                  <h2 className='text-md font-sans flex-row text-sky-400 hover-underline-animation'><span className='flex items-center'>Visit Website<ExternalLink className='mb-1'></ExternalLink></span></h2>
                                </button>
                              </a>
                            </div>
                            {/* </div> */}
                            {/* </div> */}
                          </div>
                          // </div>
                        ))}
                      </div>
                      {/* <div className=''><div className='text-white underline-offset-4 underline  font-bold text-xl text-center m-4 p-4'>Page {currentPage}</div></div>
                      <div className='flex justify-end grid grid-cols-2 '>
                        <button className='text-white bg-red-800 hover:bg-pink-600  p-4 m-4 rounded-lg transition ease-in-out hover:scale-105 transform-400 hover:shadow-[0_0_10px_white]' onClick={handleClickPrev}>Previous</button>
                        <button className='text-white bg-green-900 hover:bg-emerald-400 m-4 rounded-lg transition ease-in-out hover:scale-105 transform-400 hover:shadow-[0_0_10px_white]' onClick={handleClickNext}>Next</button>
                      </div> */}
                    </div >
                  </div >
                </div>
                {/* </div> */}
              </div>

              <div className="bg-black mt-20 py-12 sm:py-16 px-4 sm:px-6 lg:px-8 ">
                <div className="max-w-7xl mx-auto text-center flex grid justify-center items-center">
                  <div>
                    <h2 className="text-2xl sm:text-3xl md:text-4xl font-extrabold text-white">
                      <span className='font-montserrat text-5xl'>I</span>nterested to Partner With US?
                    </h2>
                    <p className="mt-3 sm:mt-4 text-lg sm:text-xl text-gray-300">
                      We're always looking for Supportive Partners.
                    </p>
                  </div>
                  <div className="">
                    <Link
                      to="/contact-us"
                      className="inline-flex items-center p-2 mt-10 font-mono  border border-transparent text-base hover:shadow-2xl  font-medium rounded-md text-white bg-blue-600 hover:bg-blue-500 transition duration-150 ease-in-out"
                    >
                      Get in Touch
                    </Link>
                  </div>
                </div>
              </div>
            </div >

          </div>
          {/* </div> */}
        </div>
      </div >
     </div>
  )
}

export default DefenceStartup
